import { render, staticRenderFns } from "./ProjectDetailView.vue?vue&type=template&id=3c61bc39&"
import script from "./ProjectDetailView.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports